export const getItems = state => state.commercialDescription.items;

export default {
	getItems,
};
